import {AfterViewInit, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import { RouterLinks } from '../../constants';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { DocumentService } from '../../documentation/services/document.service';
import { PolicyQuery } from 'src/app/modules/policy/state/policy.query';


declare var $: any;
declare var accounting: any;
declare function notify(): any;
declare function initPolicyOverviewTabs(): any;
declare function initNavPositioning(): any;

enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}

@Component({
    selector: 'app-documents-general',
    templateUrl: './documents-general.component.html',
    styleUrls: ['./documents-general.component.scss'],
    standalone: false
})
export class DocumentsGeneralComponent implements OnInit, AfterViewInit {


  policyId = '';
  selectedEntity = Entity.Policy;
  RouterLinks = RouterLinks;
  inProgress = environment.inProgress;
  documents: any;
  policy: any;
  constructor(
    public router: Router,
    private documentService: DocumentService,
    private policyQuery: PolicyQuery
  ) {
    this.policy = this.policyQuery.getActive();
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      $('#app-bar-desktop').find('#more').addClass('is-active');
       $('#overview-sub-3').removeClass('d-none');
       $('#overview-sub-3 .navbar-sub__nav').html('General documents');
    }, 2000);
  }

  ngOnInit(): void {
    this.documentService
      .getDocuments('12345')
      .subscribe((documents: any) => {
        this.documents = documents.filter( doc => doc.document_type === 'General Documents' );
      });
    
  }
  openDocument(doc: any): void {
    localStorage.setItem('previous-document-page', this.router.url);
    this.router.navigate(['/doc-document'], { state: { doc } });
  }

}
